angular.module('CarsSaraBo').factory('OneWayService', ['$resource', function($resource) {
  return $resource('../rest/company/:companyOid/oneway/:oid', 
    { companyOid : '@companyOid', oid : '@oid' },
    {
    	get:    {method:'GET'},
    	post : {method:'POST'},
    	update : { method: 'PUT' },
    	remove : { method: 'DELETE' }
    }
  )}
]);


angular.module('CarsSaraBo').factory('OneWayServiceAll', ['$resource', function($resource) {
	  return $resource('../rest/company/:companyOid/oneway/all', 
	    { companyOid : '@companyOid', amount : '@amount'},
	    {
	    	get:	{method:'GET', isArray:true},
	    	update:	{method:'PUT'},
	    	remove : { method: 'DELETE' }
	    }
	)}
]);



//////////////////
// WEBPACK FOOTER
// ./public/app/models/one_way_service.js
// module id = 856
// module chunks = 3